import * as React from "react";
import PageNavigation from "components/common/PageNavigation";
import { Row } from "components/bootstrap";
import { PAGE_NAVIGATION_TITLE } from "components/events/bindings";
const SigmaLayout = ({ children }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(PageNavigation, { page: PAGE_NAVIGATION_TITLE })), children);
export default SigmaLayout;
